import React, { useEffect, useState } from "react";
import styles from "./ModifyOrders.module.scss";
import Button from "../../../common/components/button/Button";
import InputField from "../../../common/components/formFields/inputField/inputField";
import { useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { setModifyOrdersModal } from "../../../reducerSlices/modifyOrdersSlice";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import cancelAction from "../../../assets/images/cancelToast.svg";
import { useAxios } from "../../../services/useAxios";
import { updateIsLoading } from "../../../reducerSlices/loaderSlice";
import { adminGetOrderDetailsById } from "../../../reducerSlices/adminManageOrderDetailsSlice";
import { getOrderListDetailsById } from "../../../reducerSlices/manageOrderDetails";
import deleteIcon from "../../../assets/images/deleteIcon.svg";
import { applyCreditTermMarkup } from "../../../utils/creditTerms";
import callApi from "../../../utils/api-client";
const ModifyOrders = ({
  customerId,
  orderId,
  dataTable,
  currentOrderStatus,
  minimumOrderValue,
  productSummary,
}: {
  customerId: string;
  orderId: any;
  dataTable: any;
  currentOrderStatus: string;
  minimumOrderValue: number;
  productSummary: any;
}) => {
  const { isCreditApplied, creditTermValue } = productSummary || {};
  console.info(
    "🚀 ~ ModifyOrders ~ isCreditApplied, creditTermValue:",
    isCreditApplied,
    creditTermValue,
    dataTable,
  );

  const [, setModifyOrderData] = React.useState<any>([]);
  const [isAdmin, setIsAdmin] = useState(false);
  // const [initialData, setInitialData] = useState<any>();
  const [deletedItems, setDeletedItems] = useState<any>([]);
  useEffect(() => {
    const userData = localStorage.getItem("loggedInUser");
    if (userData != null) {
      const loggedInUser = JSON.parse(userData);
      if (loggedInUser?.typeOfUser.includes("admin")) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    } else {
      setIsAdmin(false);
    }
  }, []);

  const dispatch = useDispatch();
  const tableDataShema = yup.array().of(
    yup.object().shape({
      id: yup.string(),
      productBrand: yup.string(),
      productCode: yup.string(),
      productName: yup.string(),
      updatedAmount: yup.string(),
      itemAmountUnit: yup.string(),
      orderItemsUnit: yup.string(),
      basePriceUnit: yup.string(),
      isSpecialPriceApplied: yup.boolean(),
      offer: yup.number(),
      itemAmount: yup
        .number()
        .typeError("Enter item amount")
        .required("Enter item amount")
        .test("conditional-min", function (value) {
          const { offer } = this.parent;
          if (offer === 100) {
            return value !== undefined && value >= 0.0
              ? true
              : this.createError({ message: "Min amount should be 0" });
          } else {
            return value !== undefined && value >= 0.01
              ? true
              : this.createError({ message: "Min amount should be 1" });
          }
        }),
      basePrice: yup
        .number()
        .typeError("Enter item amount")
        .required("Enter item amount")
        .test("conditional-min", function (value) {
          const { offer } = this.parent;
          if (offer === 100) {
            return value !== undefined && value >= 0.0
              ? true
              : this.createError({ message: "Min amount should be 0" });
          } else {
            return value !== undefined && value >= 0.01
              ? true
              : this.createError({ message: "Min amount should be 1" });
          }
        }),
      orderItems: yup
        .number()
        .min(0.01, "Min Qty. should be 1")
        .required("Enter order item")
        .typeError("Enter order items")
        // .test("is-decimal", "Order items should not be decimal", (value) =>
        //   Number.isInteger(value)
        // ),
        .test("is-decimal", "Qty. should have max 2 decimals", (value) => {
          if (value === undefined || value === null) {
            return true; // Allow empty values if needed
          }
          return /^\d+(\.\d{1,2})?$/.test(value.toString());
        }),
    }),
  );

  const overallSchema = yup.object({
    tableData: tableDataShema,
  });

  const {
    register,
    control,
    setValue,
    handleSubmit,
    formState: { errors },
    trigger,
  }: // getValues,
  any = useForm({
    resolver: yupResolver(overallSchema),
    defaultValues: {
      tableData: [],
    },
  });

  const handleModifyOrderModalClose = () => {
    dispatch(setModifyOrdersModal(false));
  };

  const { fields, remove } = useFieldArray({
    control,
    name: "tableData",
  });
  const [hasError, setHasError] = useState(false);
  const onChangeField = React.useCallback(
    (name: any, index: number) => (text: any) => {
      setValue(name, text);
      if (name.includes("basePrice") && isCreditApplied) {
        const buyerPrice = applyCreditTermMarkup(
          +text,
          creditTermValue ? creditTermValue : 0,
        );
        setValue(`tableData[${index}].itemAmount`, buyerPrice);
        trigger(`tableData[${index}].itemAmount`);
      } else if (name.includes("basePrice")) {
        setValue(`tableData[${index}].itemAmount`, text);
        trigger(`tableData[${index}].itemAmount`);
      }
      setModifyOrderData((prevData: any) => {
        const newData = [...prevData];
        newData[index] = {
          ...newData[index],
          line_item_id: newData[index]?.line_item_id,
          [name.endsWith("orderItems") ? "quantity" : "unit_price"]:
            text && +text,
        };
        return newData;
      });
      trigger(name);
      setHasError(false);
    },
    [setValue, setModifyOrderData],
  );

  useEffect(() => {
    if (dataTable && dataTable.length > 0) {
      const orderData = dataTable.map((item: any, index: any) => {
        return {
          id: item?.id,
          lineItemId: item?.id,
          itemAmount: item?.isSpecialPriceApplied
            ? Number(+item?.itemAmount?.split(" ")[1]).toFixed(2)
            : Number(
                +item?.itemAmount?.split(" ")[1] -
                  +item?.itemAmount?.split(" ")[1] * (item?.offer / 100),
              ).toFixed(2),
          itemAmountUnit: item?.itemAmount?.split(" ")[0],
          orderItems: Number(item?.orderItems?.split(" ")[0]),
          orderItemsUnit: item?.orderItems?.split(" ")[1],
          basePriceUnit: item?.basePrice,
          productBrand: item?.productBrand,
          productCode: item?.productCode,
          productName: item?.productName,
          updatedAmount: item?.updatedAmount,
          basePrice: item?.isSpecialPriceApplied
            ? item?.basePrice
            : Number(
                item?.basePrice - item?.basePrice * (item?.offer / 100),
              ).toFixed(2),
          isSpecialPriceApplied: item?.isSpecialPriceApplied,
          offer: item.offer,
        };
      });
      // setInitialData(orderData);
      setValue(`tableData`, orderData);
    }
  }, [dataTable]);

  const getOrderByID = useAxios({
    axiosParams: {
      url: `store/master-order/${orderId}`,
    },
    method: "GET",
  });
  const getOrderDetailsByid = async () => {
    try {
      dispatch(updateIsLoading(true));
      const response: any = await getOrderByID?.fetchData();
      if (response && response.status === "SUCCESS") {
        if (isAdmin) {
          dispatch(adminGetOrderDetailsById(response?.data?.order));
        } else {
          dispatch(getOrderListDetailsById(response?.data?.order));
        }
        dispatch(updateIsLoading(false));
      }
    } catch (error) {}
  };

  const handleModifyOrderSubmit = async (data: {
    tableData: {
      orderItems: number;
      basePrice: number;
      itemAmount: number;
      offer: number;
      isSpecialPriceApplied: boolean;
      basePriceUnit: string;
      orderItemsUnit: string;
      itemAmountUnit: string;
      updatedAmount: string;
      productName: string;
      productCode: string;
      productBrand: string;
      id: string;
      lineItemId: string;
    }[];
  }) => {
    try {
      dispatch(updateIsLoading(true));
      const body = {
        buyer_id: customerId,
        status: "modified",
        line_items: data.tableData?.map((item) => ({
          line_item_id: item?.lineItemId,
          quantity: item?.orderItems,
          unit_price: item?.itemAmount,
          base_price: item?.basePrice,
          is_special_price_applied: item?.isSpecialPriceApplied,
        })),
        delete_items: deletedItems,
      };

      const response = await callApi<any>(
        `store/master-order/modify-order/${orderId}`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
      );
      if (response && response.status === "SUCCESS") {
        getOrderDetailsByid();
        dispatch(setModifyOrdersModal(false));
      }
    } catch (error) {
      console.log("err", error);
    } finally {
      dispatch(updateIsLoading(false));
    }
  };
  const deleteItem = (id: string, index: number) => {
    remove(index);
    setDeletedItems((prev: any) => [...prev, id]);
  };
  return (
    <>
      <div className={styles.modalFullContainer}>
        <div className={styles.modalBody}>
          <div className={styles.heading}>
            <div className={styles.leftContainer}>Modify Order</div>
            <div className={styles.rightContainer}>
              <img
                src={cancelAction}
                alt=""
                onClick={handleModifyOrderModalClose}
              />
            </div>
          </div>
          <div className={styles.seperator}></div>
          <div className={styles.body}>
            <div className={styles.productListContainer}>
              <form className={styles.tableContainer}>
                <table>
                  <thead>
                    <th>Watermelon Product code</th>
                    <th>Product name</th>
                    <th>Product brand</th>
                    {isAdmin && <th>Special Price</th>}
                    <th>Quantity</th>
                    <th>
                      {isAdmin ? "Supplier Price (AED)" : "Unit Price (AED)"}
                    </th>
                    {isAdmin && <th>Buyer Price (AED)</th>}
                    {currentOrderStatus === "delivered" ? (
                      <th>Updated Amount (AED)</th>
                    ) : null}
                  </thead>
                  <tbody>
                    {fields &&
                      fields?.length > 0 &&
                      fields?.map((item: any, index) => (
                        <tr key={item?.id} className={styles.tableRow}>
                          <td>{item?.productCode}</td>
                          <td>{item?.productName}</td>
                          <td
                            className={styles.textOverflow}
                            title={item?.productBrand}
                          >
                            {item?.productBrand}
                          </td>
                          {/* is Special Price */}
                          {isAdmin && (
                            <td>
                              {item?.isSpecialPriceApplied ? "Yes" : "No"}
                            </td>
                          )}{" "}
                          {/* order items */}
                          <td>
                            <div className={styles.inputField}>
                              <div>
                                <InputField
                                  id={`tableData.${index}.orderItems`}
                                  register={register(
                                    `tableData[${index}].orderItems`,
                                  )}
                                  onChange={onChangeField(
                                    `tableData[${index}].orderItems`,
                                    index,
                                  )}
                                  type="number"
                                  width="130px"
                                  errorMessage={
                                    errors?.tableData &&
                                    errors?.tableData.length
                                      ? errors?.tableData[index]?.orderItems
                                          ?.message
                                      : ""
                                  }
                                />
                              </div>
                              {/* {isAdmin && <div>{item?.orderItemsUnit}</div>} */}
                            </div>
                          </td>
                          {/* base price */}
                          <td>
                            <div className={styles.inputField}>
                              <div>
                                <InputField
                                  id={`tableData.${index}.basePrice`}
                                  register={register(
                                    `tableData[${index}].basePrice`,
                                  )}
                                  onChange={onChangeField(
                                    `tableData[${index}].basePrice`,
                                    index,
                                  )}
                                  type="number"
                                  width="130px"
                                  // editForm={isAdmin}
                                  errorMessage={
                                    errors?.tableData &&
                                    errors?.tableData.length
                                      ? errors?.tableData[index]?.basePrice
                                          ?.message
                                      : ""
                                  }
                                />
                              </div>
                              {/* <div>x</div> */}
                            </div>
                          </td>
                          {/* buyer price */}
                          {isAdmin && (
                            <td>
                              <div className={styles.inputField}>
                                <div>
                                  <InputField
                                    // value={initialData[index]?.itemAmount}
                                    id={`tableData.${index}.itemAmount`}
                                    register={register(
                                      `tableData[${index}].itemAmount`,
                                    )}
                                    onChange={onChangeField(
                                      `tableData[${index}].itemAmount`,
                                      index,
                                    )}
                                    // disab
                                    width="130px"
                                    type="number"
                                    editForm
                                    errorMessage={
                                      errors?.tableData &&
                                      errors?.tableData.length
                                        ? errors?.tableData[index]?.itemAmount
                                            ?.message
                                        : ""
                                    }
                                  />
                                </div>
                                {/* <div>{item?.itemAmountUnit}</div> */}
                              </div>
                            </td>
                          )}
                          {/* delete */}
                          <td>
                            <div
                              className={`${styles.delete} ${
                                fields?.length <= 1 && styles.disble
                              }`}
                              onClick={
                                fields?.length <= 1
                                  ? () => {
                                      setHasError(true);
                                    }
                                  : () => deleteItem(item?.lineItemId, index)
                              }
                            >
                              <img src={deleteIcon} alt="deleteIcon" />
                            </div>
                          </td>
                          {currentOrderStatus === "delivered" ? (
                            <td>{item?.updatedAmount}</td>
                          ) : null}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </form>
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          {hasError && (
            <div
              className={styles.errorMessage}
            >{`Please reject the order instead of deleting`}</div>
          )}
          <Button
            label="Cancel"
            handleClick={() => {
              handleModifyOrderModalClose();
            }}
            width="100px"
            customClass={styles.button}
            secondary={true}
          />
          <Button
            label="Submit"
            handleClick={handleSubmit((data: any) =>
              handleModifyOrderSubmit(data),
            )}
            width="100px"
            customClass={styles.button}
          />
        </div>
      </div>
    </>
  );
};

export default ModifyOrders;
